import { render } from "./ButtonAssetType.vue?vue&type=template&id=05b460fa"
import script from "./ButtonAssetType.vue?vue&type=script&lang=js"
export * from "./ButtonAssetType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__